import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScrapingWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2507_4530",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2507_4530)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.75 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H18.6L13.9 15.3C13.55 15.5333 13.1708 15.7083 12.7625 15.825C12.3542 15.9417 11.9333 16 11.5 16C10.25 16 9.1875 15.5625 8.3125 14.6875C7.4375 13.8125 7 12.75 7 11.5C7 10.25 7.4375 9.1875 8.3125 8.3125C9.1875 7.4375 10.25 7 11.5 7C12.75 7 13.8125 7.4375 14.6875 8.3125C15.5625 9.1875 16 10.25 16 11.5C16 11.95 15.9417 12.375 15.825 12.775C15.7083 13.175 15.5333 13.55 15.3 13.9L19.4 18H20V6H4V18H13.75L15.75 20ZM11.5 14C12.2 14 12.7917 13.7583 13.275 13.275C13.7583 12.7917 14 12.2 14 11.5C14 10.8 13.7583 10.2083 13.275 9.725C12.7917 9.24167 12.2 9 11.5 9C10.8 9 10.2083 9.24167 9.725 9.725C9.24167 10.2083 9 10.8 9 11.5C9 12.2 9.24167 12.7917 9.725 13.275C10.2083 13.7583 10.8 14 11.5 14Z",
			fill: "white"
		})
	})]
});
export default SvgScrapingWhite;
